import { render, staticRenderFns } from "./order-summary.vue?vue&type=template&id=0f193d9e&"
import script from "./order-summary.vue?vue&type=script&lang=js&"
export * from "./order-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports